export default __webpack_public_path__ + "static/media/expBook.52f39d5a.png";